import DeudaImportPage from "./DeudaImportPage";

export {DeudaImportPage}
export default DeudaImportPage
